"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorksheetFormattingChangedEvent = void 0;
const Contract = require("@tableau/api-external-contract-js");
const TableauWorksheetEvent_1 = require("./TableauWorksheetEvent");
class WorksheetFormattingChangedEvent extends TableauWorksheetEvent_1.TableauWorksheetEvent {
    constructor(worksheet, _formatting) {
        super(Contract.TableauEventType.WorksheetFormattingChanged, worksheet);
        this._formatting = _formatting;
    }
    get formatting() {
        return this._formatting;
    }
}
exports.WorksheetFormattingChangedEvent = WorksheetFormattingChangedEvent;
//# sourceMappingURL=WorksheetFormattingChangedEvent.js.map